import { ROLL_DICE, HOLD_SCORE, NEW_GAME } from "./actionTypes";

const initialState = {
  scores: [0, 0],
  currentScore: 0,
  activePlayer: 0,
  playing: true,
  dice: 1,
};

export default function gameReducer(state = initialState, action) {
  switch (action.type) {
    case ROLL_DICE:
      const dice = Math.floor(Math.random() * 6) + 1;
      if (dice !== 1) {
        return { ...state, currentScore: state.currentScore + dice, dice };
      } else {
        return {
          ...state,
          currentScore: 0,
          activePlayer: state.activePlayer === 0 ? 1 : 0,
          dice,
        };
      }
    case HOLD_SCORE:
      const updatedScores = [...state.scores];
      updatedScores[state.activePlayer] += state.currentScore;
      return {
        ...state,
        scores: updatedScores,
        currentScore: 0,
        activePlayer: state.activePlayer === 0 ? 1 : 0,
        playing: updatedScores[state.activePlayer] >= 100 ? false : true,
      };
    case NEW_GAME:
      return initialState;
    default:
      return state;
  }
}
